module.exports = __webpack_public_path__ + "static/media/1-5.5a373ba5.jpg";